import { IUploadInstanceOptions } from './Uploader/type';

export type FileUploaderParams = IUploadInstanceOptions;

import { Uploader } from './Uploader/CommonUploader/index';

export class FileUploader extends Uploader {
  constructor(props: IUploadInstanceOptions) {
    super(props);
  }
  public async cancelUpload() {
    return await this.cancel();
  }
}
